import { useEffect, useState } from "react";
import { fetchJobs } from "../api";
import "../styles/global.css";

function Careers() {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedJob, setSelectedJob] = useState(null); // ✅ Modal state

  useEffect(() => {
    fetchJobs().then((data) => {
      setJobs(data);
      setLoading(false);
    });
  }, []);

  return (
    <div className="careers-container">
      <h1 className="careers-title">Join Our Team</h1>
      <p className="careers-subtitle">Explore exciting opportunities with us!</p>

      {loading ? (
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p className="loading-text">Fetching job listings...</p>
        </div>
      ) : jobs.length > 0 ? (
        <div className="job-grid">
          {jobs.map((job) => (
            <div key={job._id} className="job-card">
              
              {/* ✅ Clickable Job Title */}
              <h3
                className="job-title"
                style={{ cursor: "pointer", color: "#F48039" }}
                onClick={() => setSelectedJob(job)}
              >
                {job.title}
              </h3>

              {/* ✅ View Requirements button */}
             <button
               className="view-req-btn"
                 onClick={() => setSelectedJob(job)}
              >
                  View Requirements
              </button>


              {/* Apply Button */}
              <button
                className="apply-button"
                onClick={() => window.open(job.applyLink, "_blank")}
              >
                Apply Now
              </button>
            </div>
          ))}
        </div>
      ) : (
        <div className="no-jobs-container">
          <p className="no-jobs-text">No job openings available at the moment.</p>
        </div>
      )}

      <p style={{ marginTop: "30px", fontSize: "18px", textAlign: "center" }}>
        For career inquiries, contact us at{" "}
        <a
          href="mailto:recruitment@shehabcorp.com"
          style={{ color: "#F48039", fontWeight: "bold", textDecoration: "underline" }}
        >
          recruitment@shehabcorp.com
        </a>
      </p>

{/* ✅ Modal */}
{selectedJob && (
  <div className="modal-overlay" onClick={() => setSelectedJob(null)}>
    <div className="modal-box" onClick={(e) => e.stopPropagation()}>
      <h3>{selectedJob.title}</h3>
      <h4>Job Requirements:</h4>

      <ul>
        {selectedJob.requirements.map((req, i) => (
          <li key={i}>{req}</li>
        ))}
      </ul>

      {/* ✅ Apply Inside Modal */}
      <button
        style={{
          background: "#F48039",
          padding: "10px 20px",
          border: "none",
          borderRadius: "6px",
          color: "#fff",
          fontWeight: "bold",
          cursor: "pointer",
          width: "100%",
          marginTop: "15px"
        }}
        onClick={() => window.open(selectedJob.applyLink, "_blank")}
      >
        Apply Now
      </button>

      {/* ✅ Close Modal */}
      <button
        style={{
          marginTop: "10px",
          background: "#ccc",
          padding: "10px 20px",
          border: "none",
          borderRadius: "6px",
          color: "#333",
          cursor: "pointer",
          width: "100%"
        }}
        onClick={() => setSelectedJob(null)}
      >
        Close
      </button>
    </div>
  </div>
)}

    </div>
  );
}

export default Careers;
